export default __webpack_public_path__ + "static/slovenia-control1-fca4147e0362b678dac84165a51bafca.png";